import React, { Suspense } from 'react'
import { Spin } from 'dingtalk-design-mobile';

const widthLazy =  Component =>
  <Suspense fallback={<Spin text="加载中" fixed />}>
    <Component />
  </Suspense>

export default widthLazy
